define([
    'common/ui/view/svg/text/path',
    'common/ui/view/svg/shape/index',
    'victor'
], function(
    TextpathView,
    Shape,
    Victor
    ) {
    var EllipseShape = Shape.extend({
        tagName: 'ellipse',
        initialize: function(params) {
            EllipseShape.__super__.initialize.call(this, params);
            this._width = this.params.rx * 2;
            this._height = this.params.ry * 2;
            this._rx = this.params.rx;
            this._ry = this.params.ry;
        },

        imageOffset: function() {
            var imageSize = this.imageSize();
            return {
                x: - imageSize / 2,
                y: - imageSize / 2
            };
        },

        render: function() {
            this.$el
                .attr('rx', this._rx)
                .attr('ry', this._ry);

            return this;
        },

        createTextpath: function(params) {
            const fromX = - this._rx;
            const fromY = 0;
            const toX = this._rx;
            const toY = 0;
            const rx = this._rx;
            const ry = this._ry;
            const clockwise = 1;

            const path = `M ${fromX},${fromY} A ${rx},${ry} 0 0,${clockwise} ${toX},${toY}`
            return new TextpathView({
                id: params.id,
                path: path,
                offset: '50%'
            });
        },

        _getEllipsePos: function(angle, offset) {
            offset = offset ? offset : 0;
            var rx = this._rx + offset;
            var ry = this._ry + offset;
            return {
                x: rx * Math.cos(angle / 180 * Math.PI),
                y: - ry * Math.sin(angle / 180 * Math.PI)
            };
        },

        getBottomRightPoints: function(params) {
            var interval = params.interval;
            var points = [];
            var theta = 330;

            while(true) {
                var dTheta = interval / Math.sqrt(
                    Math.pow(this._ry * Math.cos(theta / 180 * Math.PI), 2) +
                    Math.pow(this._rx * Math.sin(theta / 180 * Math.PI), 2)
                    ) / Math.PI * 180;
                theta -= dTheta;
                var point = this._getEllipsePos(theta, 0);

                if(point.x < interval) {
                    break;
                }
                points.push(point);
            }

            return points;
        },

        getBottomLeftPoints: function(params) {
            var interval = params.interval;
            var points = [];
            var theta = 210;

            while(true) {
                var dTheta = interval / Math.sqrt(
                    Math.pow(this._ry * Math.cos(theta / 180 * Math.PI), 2) +
                        Math.pow(this._rx * Math.sin(theta / 180 * Math.PI), 2)
                ) / Math.PI * 180;
                theta += dTheta;
                var point = this._getEllipsePos(theta);

                if(point.x > interval) {
                    break;
                }
                points.push(point);
            }

            return points;
        },

        getBorderPoint: function(direction, offset) {
            var angle = (- direction.angleDeg() + 360) % 360;
            return Victor.fromObject(this._getEllipsePos(angle, offset));
        },

        getBorderTangent: function(direction, offset) {
            var angle = (- direction.angleDeg() + 360) % 360;
            offset = offset ? offset : 0;
            var rx = this._rx + offset;
            var ry = this._ry + offset;
            return Victor.fromObject({
                x: ry * Math.cos(angle / 180 * Math.PI),
                y: - rx * Math.sin(angle / 180 * Math.PI)
            }).norm();
        }
    }, {
        type: 'ellipse'
    });

    return EllipseShape;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/ellipse.js